export default __webpack_public_path__ + "static/media/cp_okt_okt.dd60f2b7.svg";